import { render } from "./spotTheDiff.vue?vue&type=template&id=89b50cd2&scoped=true&ts=true"
import script from "./spotTheDiff.vue?vue&type=script&lang=ts"
export * from "./spotTheDiff.vue?vue&type=script&lang=ts"

import "./spotTheDiff.vue?vue&type=style&index=0&id=89b50cd2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89b50cd2"]])

export default __exports__